import fetch from "./fetch";
/**
 * 资讯管理
 */
const consult = {
  //发布资讯
  addConsult(data) {
    return fetch({
      isLoading: true,
      url: "/v1/information/save",
      method: "POST",
      data,
    });
  },
  //查询科室
  getDepartment(params) {
    return fetch({
      isLoading: true,
      url: "/v1/department/selectAll",
      method: "GET",
      params,
    });
  },
  //查询相关推荐
  getConsultRecommend(params) {
    return fetch({
      isLoading: true,
      url: "/v1/information/selectAll",
      method: "GET",
      params,
    });
  },
  //获取标签
  getTags(params) {
    return fetch({
      isLoading: true,
      url: "/v1/label/selectAll",
      method: "GET",
      params,
    });
  },
  //新增标签
  addTag(data) {
    return fetch({
      isLoading: true,
      url: "/v1/label/save",
      method: "POST",
      data,
    });
  },
  //资讯列表查询
  getConsult(params) {
    return fetch({
      isLoading: true,
      url: "/v1/information/page",
      method: "GET",
      params,
    });
  },
  //上传富文本图片
  uploadFullTextImage(data) {
    return fetch({
      isLoading: true,
      url: "/file-data/uploads",
      method: "POST",
      data,
      headers: {
        // 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarynl6gT1BKdPWIejNq'
        "Content-Type": "multipart/form-data",
      },
    });
  },
  //根据id获取图片
  getImg(params) {
    return fetch({
      isLoading: true,
      url: "/file-data/getUrl",
      method: "GET",
      params,
    });
  },
  //编辑资讯
  editConsult(data) {
    return fetch({
      isLoading: true,
      url: "/v1/information/update",
      method: "POST",
      data,
    });
  },
  //详情
  getConsultDetail(params) {
    return fetch({
      isLoading: true,
      url: "/v1/information/detail",
      method: "GET",
      params,
    });
  },
};

export default consult;
